<div class="override-toggle">
    <cerrix-checkbox
        data-uiid="framework-assessment-scores-use-parent"
        [label]="'frameworkAssessmentScores.useParentOrDefaultScoresLabel' | transloco"
        [(value)]="row.UseParentOrDefaultScores"
        (valueChange)="useParentOrDefaultChecked($event)"
    ></cerrix-checkbox>
</div>
<hr />
@if (row.UseParentOrDefaultScores && row.ParentScores) {
    <div class="parent-matrix-viewer">
        <label>{{ "frameworkAssessmentScores.parentScoresPreview" | transloco }}</label>
    </div>
}
@if (listConfig) {
    <div class="sub-list-manager">
        <ng-container
            *ngComponentOutlet="listManagerType; inputs: { config: listConfig }"
        ></ng-container>
    </div>
}
